// HASLO: quick add on product cards. Markup: snippets/haslo-quick-add.liquid.
// Adding to cart is Focal's <form is="product-form"> (cart call, mini-cart refresh, one notification).
// This element only handles: opening the size strip on touch/keyboard, the added state, and the
// aria-live announcement. Strings come from data- attributes rendered from locales.

class HasloQuickAdd extends HTMLElement {
  connectedCallback() {
    this.trigger = this.querySelector('.haslo-quick-add__trigger');
    this.status = this.querySelector('[data-haslo-status]');
    this.onOutside = (event) => {
      if (!this.contains(event.target)) this.toggle(false);
    };

    // Size mode: the "+" is a toggle (aria-expanded). Single mode: it's a submit button.
    if (this.trigger && this.trigger.hasAttribute('aria-expanded')) {
      this.trigger.addEventListener('click', (event) => {
        this.toggle(true);
        // Keyboard activation (detail 0): move focus to the first size that can be added
        if (event.detail === 0) this.querySelector('.haslo-quick-add__size:not([disabled])')?.focus();
      });

      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.hasAttribute('open')) {
          this.toggle(false);
          this.trigger.focus();
        }
      });
    }

    // Both events bubble up from Focal's product-form inside this element
    this.addEventListener('variant:added', (event) => this.added(event.target));
    this.addEventListener('cart-notification:show', (event) => {
      if (event.detail?.status === 'error') this.announce(this.dataset.error);
    });
  }

  disconnectedCallback() {
    document.removeEventListener('pointerdown', this.onOutside);
    clearTimeout(this.addedTimer);
  }

  toggle(open) {
    this.toggleAttribute('open', open);
    this.trigger.setAttribute('aria-expanded', String(open));
    if (open) {
      document.addEventListener('pointerdown', this.onOutside);
    } else {
      document.removeEventListener('pointerdown', this.onOutside);
    }
  }

  added(form) {
    const button = form.querySelector('button[type="submit"]');
    clearTimeout(this.addedTimer);
    this.setAttribute('added', '');
    button?.classList.add('is-added');
    this.announce(this.dataset.added);

    this.addedTimer = setTimeout(() => {
      this.removeAttribute('added');
      button?.classList.remove('is-added');
      if (this.hasAttribute('open')) this.toggle(false);
    }, 1400);
  }

  announce(message) {
    if (!this.status || !message) return;
    // Clear first so the same message is announced again on a repeat add
    this.status.textContent = '';
    requestAnimationFrame(() => (this.status.textContent = message));
  }
}

if (!customElements.get('haslo-quick-add')) {
  customElements.define('haslo-quick-add', HasloQuickAdd);
}
